import { use } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { getTestProps } from '../../../lib/helpers';

import Button from '../../../components/Button/Button';

import { ModalInstanceContext } from '../../../contexts/ModalContext';

import { FlotiqLogo } from '../../../images/shapes';

interface PopulateSpaceErrorContentProps {
  errorMessage: string;
  testId?: string;
}

const PopulateSpaceErrorContent = ({
  errorMessage,
  testId,
}: PopulateSpaceErrorContentProps) => {
  const { t } = useTranslation();

  const modalInstance = use(ModalInstanceContext);

  return (
    <div
      className="flex flex-col justify-center gap-3"
      {...getTestProps(testId, 'error-container')}
    >
      <div>
        <FlotiqLogo className="h-8" />
      </div>
      <span className="text-center font-bold text-3xl/[32px] mb-3 md:text-4xl/[32px]">
        {t('PopulateSpaceModal.ModalError.Header')}
      </span>
      <p className="text-center text-slate-900 my-3 dark:text-slate-200">
        <Trans
          i18nKey="PopulateSpaceModal.ModalError.Paragraph"
          components={{
            1: (
              <a
                aria-label="Report error"
                className={
                  'font-bold text-slate-900 border-b border-indigo-950 cursor-pointer' +
                  ' hover:text-slate-900 hover:decoration-0 hover:no-underline dark:text-slate-200 dark:border-white' +
                  ' focus:no-underline focus:text-slate-900'
                }
                href="mailto:hello@flotiq.com"
              ></a>
            ),
          }}
        />
      </p>
      <p className="text-center text-red font-bold my-3">{errorMessage}</p>
      <div className="flex gap-3 justify-center">
        <Button
          buttonColor="blue"
          onClick={() => modalInstance.resolve?.(true)}
          {...getTestProps(testId, 'error-try-again')}
        >
          {t('PopulateSpaceModal.ModalError.TryAgain')}
        </Button>
        <Button
          buttonColor="blueBordered"
          onClick={() => modalInstance.resolve?.(false)}
        >
          {t('Global.Cancel')}
        </Button>
      </div>
    </div>
  );
};

export default PopulateSpaceErrorContent;
